import { TeamNetRatingChart } from "./TeamNetRatingChart";
import { Button, Flex, Text } from "@suns/design-system";
import { TeamPpvChart } from "./TeamTpvChart";
// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import { TeamMetadataRow, TeamRow } from "@suns/api/generated-client/apollo";
import { TeamTrvChart } from "./TeamTrvChart";
import { useState } from "react";
import { SEASON_RANGES } from "@/shared/utils/nba-season";
import dayjs from "dayjs";
import { Timeframe } from "@/shared/const";

export function TeamAnalytics({ team }: { team: TeamRow }) {
  const [selectedTimeFrame, setSelectedTimeFrame] = useState<Timeframe>(
    // @ts-expect-error - DO NOT COPY THIS LINE
    SEASON_RANGES[SEASON_RANGES.length - 1].label
  );

  const seasonRange = SEASON_RANGES.find(
    (season) => season.label === selectedTimeFrame
  );

  const filteredTeamMetadata = team.metadata?.filter(
    (item: TeamMetadataRow) => {
      const season = item.snapshotDate;
      return dayjs(season).isBetween(
        seasonRange?.start,
        seasonRange?.end,
        null,
        "[]"
      );
    }
  );

  const timeFrames = SEASON_RANGES.map((season) => season.label);

  return (
    <Flex direction="down" gap="lg">
      <Flex direction="down" gap="md">
        <Flex direction="down" gap="md">
          <Flex gap="sm">
            {timeFrames.map((timeFrame) => (
              <Flex key={timeFrame} align="center">
                <Button
                  key={timeFrame}
                  variant={
                    selectedTimeFrame === timeFrame ? "default" : "ghost"
                  }
                  onClick={() => setSelectedTimeFrame(timeFrame)}
                  size="xs"
                >
                  <Text size="sm">{timeFrame}</Text>
                </Button>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
      <Flex gap="lg" className="flex-col md:flex-row">
        <TeamNetRatingChart
          teamMetadata={filteredTeamMetadata}
          timeframe={selectedTimeFrame}
        />
        <TeamPpvChart
          teamMetadata={filteredTeamMetadata}
          timeframe={selectedTimeFrame}
        />
      </Flex>
      <Flex gap="lg" className="flex-col md:flex-row">
        <TeamTrvChart
          teamMetadata={filteredTeamMetadata}
          timeframe={selectedTimeFrame}
        />
      </Flex>
    </Flex>
  );
}
